import { Body1, Flex } from '@sainsburys-tech/fable'
import { ArrowLeft } from '@sainsburys-tech/icons'
import React from 'react'
import { Link } from 'react-router-dom'

const BackButton = (linkPath: string, message: string) => (
  <Link
    to={{ pathname: linkPath }}
    data-testid='back-button'
    className='c-link-black'
  >
    <Flex direction={'row'}>
      <ArrowLeft height='25px' />
      <Body1 style={{ marginLeft: '10px', fontWeight: 'bold' }}>
        {message}
      </Body1>
    </Flex>
  </Link>
)

export default BackButton
